import React, { PropsWithChildren } from 'react';

export default function AkGreyBg({ children }: PropsWithChildren<{}>) {
    return <span style={{ backgroundColor: '#A8A8A8' }}>{children}</span>;
}
